import React from "react";

import icon from "./icon.svg";

function RainyIcon({ className }: { className: string }) {
  return <img className={className} src={icon} alt="Rainy" />;
}

export { RainyIcon };
